import { Backdrop, CircularProgress, Tooltip, Typography } from "@mui/material";
import DataTable from "comps/Tables/DataTable";
import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import TLinkApi from "services/tlink.api";

const SurveyPriorityConfig = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [page, setPage] = useState(1);
  const [entriesPerPage, setEntriesPerPage] = useState(50);
  const [data, setData] = useState([]);

  const fetchData = async () => {
    setIsLoading(true);
    try {
      let data = await TLinkApi.get(
        `/configurations/survey-priority`
      );
      setData(data.data);
      setIsLoading(false);
    } catch (e) {
      setIsLoading(false);
      console.log(e);
    }
  };

  useEffect(() => {
     fetchData();
    // eslint-disable-next-line
  }, []);

 let columns = [
  {
    accessor: "client_id",
    Header: "Client Id",
    align: "left",
  },
  {
    accessor: "client_name",
    Header: "Client Name",
    align: "left",
    sortable: true,
    Cell: ({ row }) => {
      const name = row?.original?.client_name;
      if (!name) return "";
      const truncatedName =
        name?.length > 20 ? name.substring(0, 20) + "..." : name;
      return (
        <Tooltip title={name.length > 20 ? row?.original?.client_name : ""}>
          <div>{truncatedName}</div>
        </Tooltip>
      );
    },
  },
  {
    accessor: "buyer_id",
    Header: "Buyer Id",
    align: "left",
  },
  {
    accessor: "buyer_name",
    Header: "Buyer Name",
    align: "left",
    sortable: true,
    Cell: ({ row }) => {
      const name = row?.original?.buyer_name;
      if (!name) return "";
      const truncatedName =
        name?.length > 20 ? name.substring(0, 20) + "..." : name;
      return (
        <Tooltip title={name.length > 20 ? row?.original?.buyer_name : ""}>
          <div>{truncatedName}</div>
        </Tooltip>
      );
    },
  },
  {
    accessor: "language_name",
    Header: "Language Name",
    align: "center",
    headerAlign: "center",
  },
  {
    accessor: "priority_order",
    Header: "Priority Order",
    align: "center",
    headerAlign: "center",
  },
  // {
  //   accessor: "last_updated_at",
  //   Header: "Last Updated At",
  //   align: "center",
  //   headerAlign: "center",
  //   Cell: ({ row }) => {
  //     const date = row?.original?.last_updated_at;
  //     return date ? new Date(date).toLocaleString() : "";
  //   },
  // },
];


  return (
    <div>
      {isLoading ? (
        <Backdrop
          sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
          open={isLoading}
        >
          <CircularProgress color="inherit" />
        </Backdrop>
      ) : (
        ""
      )}

      <DataTable
        table={{ columns, rows: data }}
        isSorted
        entriesPerPage={entriesPerPage}
        canSearch={false}
        tablePage={page}
        setTablePage={setPage}
        setEntriesPerPage={setEntriesPerPage}
        totalLength={data.length}
        pagination={true}
        enableTopToolbar={true}
        tableMaxHeight={
           data.length === 0 ? "calc(100vh - 220px)" : "calc(100vh - 220px)"
        }
        tableMinHeight={
           data.length === 0 ? "calc(100vh - 220px)" : "calc(100vh - 220px)"
        }
        renderTopToolbarCustomActions={() => {
          return (
            <Typography variant="h6" sx={{ fontWeight: 600 }}>
              Survey Priority Configuration
            </Typography>
          );
        }}
      />
    </div>
  );
};

export default SurveyPriorityConfig;
